'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App");

$(function () {

    function tmpConfirmMessage(e) {
        e.preventDefault();
        var link = $(e.target).attr("href");
        _message2.default.confirm(resx.App.PromoboxDeletionConfirmationTitle, resx.App.PromoboxDeletionConfirmationQuestion, function (isConfirmed) {
            if (isConfirmed) {
                window.location.href = link;
            }
        });
    }

    $("#btnDelete").click(function (e) {
        tmpConfirmMessage(e);
    });

    $(document).on('click', 'a[data-position]', function () {
        var position = $(this).data('position');
        var googleMapsApiKey = 'AIzaSyAbzuHlpaYjja8LXbOY6V91EVQc8Vm3lJc';
        var mapBaseUrl = 'https://www.google.com/maps/embed/v1/place?key=' + googleMapsApiKey + '&q=';
        $('#positionModal iframe').attr('src', mapBaseUrl + position);
        $('#positionModal').modal('show');
    });

    $(document).on('change', '#signed-check', function () {
        $('#signed-filter').val($(this).is(':checked')).trigger('click');
    });
});

$('#show-tips').on('click', function () {
    $(this).closest('.tips').toggleClass('open');
});

$("input[data-observed-by]").change(function () {
    var prefix = $(this).data("observe-prefix");
    var observer = $(this).data("observed-by");
    var observerAttr = $(this).data("observer-attr");
    $(observer).attr(observerAttr, prefix + $(this).val());
});

window.getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/scripts.js
// module id = 451
// module chunks = 0